function injectStyle (ssrContext) {
  require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-4e68387d\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!../../../node_modules/string-replace-webpack-plugin/loader.js?id=os8u77dxteg!../../../node_modules/string-replace-webpack-plugin/loader.js?id=zkc3fbyssup!./DonateRgForm.vue")
}
var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!../../../node_modules/string-replace-webpack-plugin/loader.js?id=os8u77dxteg!../../../node_modules/string-replace-webpack-plugin/loader.js?id=zkc3fbyssup!./DonateRgForm.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-4e68387d\",\"hasScoped\":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!../../../node_modules/string-replace-webpack-plugin/loader.js?id=os8u77dxteg!../../../node_modules/string-replace-webpack-plugin/loader.js?id=zkc3fbyssup!./DonateRgForm.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4e68387d",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/product/DonateRgForm.vue
// module id = 274
// module chunks = 0